/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.01.01 12:30.
* @Author
* @Description  项目 数据 mock
**/

import Mock from 'mockjs'
/**
 *@Description
 *@Param
 *@Return 项目 商品详情数据 - mock数据.
 **/
export const detailData = Mock.mock({
  message: 'detailData数据',
  status: '0',
  result: {
    id: '@id',
    name:'商品名称',
    theme:'这是主题',
    content:'北极星图案一分为二，分别置于男女戒上，指引相爱的两人找到彼此，生命因此完整，人生从此不再迷失。',
    likenum:55,
    url: Mock.Random.dataImage('1050x500', 'mock 图片'),
    'listsrc|4':[{
    id: '@id',
    url: '../../assets/img/xx.jpg',
    }]
  }
})
/**
 *@Description
 *@Param
 *@Return 项目 banner数据 - mock数据.
 **/
export const bannerList = Mock.mock({
  message: 'banner数据',
  status: '000000000',
  result: [{
    id: '@id',
    src: Mock.Random.dataImage('1050x500', 'mock 图片'),
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 首页 主体区域 数据 - mock数据.
 **/
export const contentList = Mock.mock({
  message: 'content 主体数据',
  status: '000000000',
  result: [{
    id: '@id',
    flag: '预览',
    title: '新时尚',
    content: '时尚钻饰',
    src: '../../assets/img/xx.jpg',
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 品牌栏目 区域 数据 企业资讯、最新活动、时尚资讯 - mock数据.
 **/
export const brandList = Mock.mock({
  message: '品牌栏目数据',
  status: '000000000',
  result: {
    total: '@number',
    'pageNum|20-30': '@number',
    pageSize: 9,
    'list|10-20': [{
      id: '@id',
      time: '@date("yyyy-MM-dd")',
      title: '第三届金友福珠宝丽人启动',
      url: Mock.Random.dataImage('300x265', 'mock 图片'),
    }]
  }
})
/**
 *@Description
 *@Param
 *@Return 项目 产品验证查询系列结果 - mock数据.
 **/
export const searchList = Mock.mock({
  message: '产品查询结果 数据',
  status: '000000000',
  result: {
    message: '产品查询结果',
  }
})
/**
 *@Description
 *@Param
 *@Return 项目 逛店模块 - 查找店铺 区域 结果 - mock数据.
 **/
export const areaList = Mock.mock({
  message: '查找店铺所在区域 数据',
  status: '000000000',
  'result|10-20': [{
    id: '@id',
    areaName: '@city'
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 逛店模块 - 查找店铺 结果 - mock数据.
 **/
export const storeMockList = Mock.mock({
  message: '查找店铺 数据',
  status: '000000000',
  result: {
    total: 3,
    pageSize: 1,
    list: [{
      id: '101',
      tel: '02226825188',
      name: '金友福珠宝北辰店',
      areaCode: '022',
      area: '天津市北辰区京津公路金福隆商厦三楼'
    },{
      id: '102',
      tel: '02224934666',
      name: '金友福珠宝东丽店',
      areaCode: '022',
      area: '天津市东丽区跃进路39号东丽商场一楼'
    },{
      id: '103',
      tel: '02225895999',
      name: '金友福珠宝大洋店',
      areaCode: '022',
      area: '天津市海滨新区塘沽和平路529号大洋百货一楼'
    }]
  }
})
/**
 *@Description
 *@Param
 *@Return 项目 新品模块 - mock数据.
 **/
export const newList = Mock.mock({
  message: '新品 数据',
  status: '000000000',
  'result|3-10':[{
    id: '@id',
    type: '1',
    url: Mock.Random.dataImage('320x230', 'mock 图片'),
    name: '@cname',
    'list|3-10': [{
      id: '@id',
      type: '1',
      url: Mock.Random.dataImage('220x200', 'mock 图片'),
      name: '北极星系列-004',
      router: 'detail',
    }]
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 招聘 模块 - mock数据.
 **/
export const recruitList = Mock.mock({
  message: '招聘 数据',
  status: '000000000',
  'result|3-10':[{
    id: '@id',
    position: '店长',
    'number|5-10': 5,
    'area|2-5': 3,
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 TVC 模块 视频播放列表 - mock数据.
 **/
export const videoList = Mock.mock({
  message: '视频播放列表 数据',
  status: '000000000',
  result:[{
    id: '@id',
    type: '品牌',
    name: '品牌',
    list: [{
      id: '@id',
      name: '《品牌篇》',
      url: '',
    }]
  },{
    id: '@id',
    type: '新品上市',
    name: '新品上市',
    list: [{
      id: '@id',
      name: '唯你爱新品发布会',
      url: '',
    }, {
      id: '@id',
      name: '一次心新品上市——77对情侣登顶中原福塔',
      url: '',
    }]
  },{
    id: '@id',
    type: '珠宝丽人',
    name: '珠宝丽人',
    list: [{
      id: '@id',
      name: '珠宝丽人决赛视频',
      url: '',
    }]
  },{
    id: '@id',
    type: '微电影',
    name: '微电影',
    list: [{
      id: '@id',
      name: '特殊约会',
      url: '',
    }]
  },{
    id: '@id',
    type: '产品篇',
    name: '产品篇',
    list: [{
      id: '@id',
      name: '至i新品宣传视频',
      url: '',
    }]
  }]
})

/**
 *@Description
 *@Param
 *@Return 项目 导航数据 - mock数据.
 **/
export const navList = Mock.mock({
  message: '导航数据',
  status: '000000000',
  result: [{
    id: '@id',
    name: '首页',
    router: 'home',
    english: 'HOME',
  }, {
    id: '@id',
    name: '品牌',
    router: 'brand',
    english: 'Brand',
  }, {
    id: '@id',
    name: '逛店',
    router: 'store',
    english: 'Stores',
  }, {
    id: '@id',
    name: '新品',
    router: 'news',
    english: 'News',
  }, {
    id: '@id',
    name: '珠宝',
    router: 'jewelry',
    english: 'Brilliant Jewelry',
  }]
})

/**
 *@Description
 *@Param
 *@Return 项目 右侧浮动导航数据 - mock数据.
 **/
export const floatList = Mock.mock({
  message: '浮动导航数据',
  status: '000000000',
  result: [{
    type: '系列',
    name: 'Series',
    list: [{
      id: '@id',
      router: 'QueryValid',
      name: 'MyStar'
    }, {
      id: '@id',
      router: 'QueryValid',
      name: 'JustLove'
    }, {
      id: '@id',
      router: 'query',
      name: '至I'
    }, {
      id: '@id',
      router: 'query',
      name: '一次心'
    }, {
      id: '@id',
      router: 'query',
      name: '+彩金'
    }, {
      id: '@id',
      router: 'query',
      name: 'mimi小姐'
    }, {
      id: '@id',
      router: 'query',
      name: '至I满金'
    }, {
      id: '@id',
      router: 'query',
      name: '知竹系列'
    }, {
      id: '@id',
      router: 'query',
      name: '拥有'
    }, {
      id: '@id',
      router: 'query',
      name: '雪花'
    }, {
      id: '@id',
      router: 'query',
      name: '至I二代'
    }]
  }, {
    type: '材质',
    name: 'Material',
    list: [{
      id: '@id',
      router: 'query',
      name: '钻石'
    }, {
      id: '@id',
      router: 'query',
      name: '黄金'
    }, {
      id: '@id',
      router: 'query',
      name: '彩宝'
    }, {
      id: '@id',
      router: 'query',
      name: 'K金'
    }, {
      id: '@id',
      router: 'query',
      name: '铂金'
    }]
  }, {
    type: '品质',
    name: 'Category',
    list: [{
      id: '@id',
      router: 'query',
      name: '项链'
    }, {
      id: '@id',
      router: 'query',
      name: '手镯'
    }, {
      id: '@id',
      router: 'query',
      name: '手链'
    }, {
      id: '@id',
      name: '戒指'
    }, {
      id: '@id',
      router: 'query',
      name: '耳饰'
    }, {
      id: '@id',
      router: 'query',
      name: '吊坠'
    }]
  }]
})
/**
 *@Description
 *@Param
 *@Return 项目 底部数据 - mock数据.
 **/
export const footerList = Mock.mock({
  message: '脚部数据',
  status: '000000000',
  result: [{
    title: '关于金友福',
    list: [{
      id: '@id',
      name: '简介',
      router: 'introduction'
    }, {
      id: '@id',
      name: '店铺',
      router: 'shop'
    }]
  }, {
    title: '会员',
    list: [{
      id: '@id',
      name: '会员俱乐部',
      router: 'vip'
    }, {
      id: '@id',
      name: '会员查询',
      router: 'vipSearch'
    }]
  }, {
    title: '人才',
    list: [{
      id: '@id',
      name: '招聘',
      router: 'recruit'
    }, {
      id: '@id',
      name: '团队',
      router: 'team'
    }]
  }, {
    title: '服务',
    list: [{
      id: '@id',
      name: '珠宝知识',
      router: 'knowledge'
    }, {
      id: '@id',
      name: '售后服务',
      router: 'afterSale'
    }, {
      id: '@id',
      name: '产品查询',
      router: 'QueryValid'
    }]
  }, {
    title: '联系',
    list: [{
      id: '@id',
      name: '在线联系',
      router: 'contactUs'
    }, {
      id: '@id',
      name: '400电话',
      router: 'telephone'
    }]
  }, {
    title: '链接',
    list: [{
      id: '@id',
      name: '微官网'
    }, {
      id: '@id',
      name: '微信'
    }, {
      id: '@id',
      name: '微博'
    }, {
      id: '@id',
      name: '百度',
      url:"https://www.baidu.com"
    }]
  }]
})

